/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  PaginatedTeasers
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Active Teasers
 */
export const listActiveTeasers = (

 signal?: AbortSignal
) => {


      return axiosClient<PaginatedTeasers>(
      {url: `/teasers`, method: 'GET', signal
    },
      );
    }




export const getListActiveTeasersQueryKey = () => {
    return [
    'teasers'
    ] as const;
    }


export const getListActiveTeasersQueryOptions = <TData = Awaited<ReturnType<typeof listActiveTeasers>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveTeasers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListActiveTeasersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActiveTeasers>>> = ({ signal }) => listActiveTeasers(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActiveTeasers>>, TError, TData>
}

export type ListActiveTeasersQueryResult = NonNullable<Awaited<ReturnType<typeof listActiveTeasers>>>
export type ListActiveTeasersQueryError = ErrorType<void>


/**
 * @summary List of Active Teasers
 */

export function useListActiveTeasers<TData = Awaited<ReturnType<typeof listActiveTeasers>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveTeasers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActiveTeasersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






